if (!customElements.get('noyvad-sticky-buy')) {
  customElements.define('noyvad-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      const target = document.getElementById(this.dataset.target);
      const button = this.querySelector('button');
      if (!target || !button || !('IntersectionObserver' in window)) return;
      this.sync = () => {
        button.disabled = target.disabled || target.getAttribute('aria-disabled') === 'true';
        button.textContent = target.querySelector('span')?.textContent.trim() || button.textContent;
      };
      this.buy = () => { if (!button.disabled) target.click(); };
      button.addEventListener('click', this.buy);
      this.button = button;
      this.sync();
      this.visibility = new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }, { threshold: 0 });
      this.visibility.observe(target);
      this.state = new MutationObserver(this.sync);
      this.state.observe(target, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true });
    }
    disconnectedCallback() {
      this.visibility?.disconnect();
      this.state?.disconnect();
      this.button?.removeEventListener('click', this.buy);
    }
  });
}
